import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 0;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "Company",
  "Location",
  "Department",
  "Area",
  "Plan / Facility",
  "Equipment",
  "Equipment Type",
  "Equipment Capacity",
  "Equipment Tag",
  "Sub - Equipment",
  "Sub - Equipment Tag",
  "Device / Instruction",
  "Device / Inst Tag",
  "Work Permit",
  "Job Native",
  "Job Priority",
  "Job Status",
  "Order Type",
  "Vendor Creation",
  "Created By User Creation",
  "Reported By User Creation",
  "Attended By User Creation",
  "Employee Creation",
  "User Role Creation"
];

function getStyles(name, multiSelectVal, theme) {
  return {
    fontWeight: multiSelectVal?.includes?.(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

export default function MultipleSelectChip({ 
    defaultValue = [], handleFieldChange, label
}) {
  const theme = useTheme();
  const [multiSelectVal, setMultiSelectVal] = React.useState(defaultValue || []);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    // On autofill we get a stringified value.
    const updatedVal = typeof value === 'string' ? value.split(',') : value;
    setMultiSelectVal(updatedVal);
    handleFieldChange({
        target: { value: updatedVal }
    });
  };

  return (
    <div>
      <FormControl sx={{ width: 300 }}>
        <InputLabel id="demo-multiple-chip-label">{label}</InputLabel>
        <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={multiSelectVal}
          onChange={handleChange}
          input={<OutlinedInput id="select-multiple-chip" label={label} />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {names.map((name) => (
            <MenuItem
              key={name}
              value={name}
              style={getStyles(name, multiSelectVal, theme)}
            >
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
